export const subscribeMenuList = {
  //视频巡店
  SHOP_LIST: { id: 10001, icon: 'emap' }, //门店列表

  //巡店报表
  REPORT_DETAILS_TREND_NEW: { id: 1036, icon: 'xdtrend_report' }, //巡店趋势报表
  INSPECT_SHOP_RECORDS: { id: 1058, icon: 'xdtask_report' }, //巡店记录
  REPORT_DETAILS_RANK_NEW: { id: 915, icon: 'xdtops_report' }, //巡店排名报表
  //REPORT_DETAILS_DIMENSION:{id:10807,icon:'report_details_dimension'},//巡店维度报表

  //点检中心
  CHECK_TASK: { id: 10601, icon: 'checktask' }, //点检任务
  CHECK_REPORT: { id: 10602, icon: 'checktask_report' }, //点检报表
  //CHECK_CONFIG:{id:10604,icon:'checktask_config'},//点检配置

  //图片中心
  PHOTO_MANAGE: { id: 10401, icon: 'picture_index' }, //图片管理

  //问题列表
  PROBLEM_LIST: { id: 10701, icon: 'problem_index' }, //问题列表

  //计划巡店
  STORE_PLAN_PROCESS_CONFIG: { id: 12001, icon: 'store_plan_process_config' }, //审核流程配置
  STORE_PLAN_REPORT: { id: 12002, icon: 'store_plan_report' }, //任务巡店报表

  // 店探
  SHOP_AGENT_TASK_VERIFY: { id: 14001, icon: 'shop_agent_task' }, //店探任务审核
  SHOP_AGENT_REPORT: { id: 14002, icon: 'shop_agent_report' }, //店探排名报表
  SHOP_AGENT_TRENDING_REPORT: { id: 14003, icon: 'shop_agent_trending_report' }, //店探趋势报表
  SHOP_AGENT_ANALYSIS_REPORT: { id: 14004, icon: 'shop_agent_analysis_report' }, //店探分析报表
  BIRD_SCOUT_DATA_BOARD_NEW: { id: 14005, icon: 'new_shop_agent_report' }, //新店探报表
  //追溯
  //POS_WARNING_MANAGE:{id:12101,icon:'pos_warning_manage'},//异常订单管理
  //POS_WARNING_HISTORICAL_RECORD:{id:12102,icon:'historical_record'},//历史记录
  //TRACK_STORAGE_REPORT:{id:12103,icon:'historical_record'},//仓储追溯报表
  //TRACK_POS_REPORT:{id:12104,icon:'historical_record'},//POS追溯报表

  //任务中心
  TASK_CENTRE: { id: 12201, icon: 'task_index' }, //任务中心
  //TASK_REPORT:{id:12202,icon:'task_report'},//任务报表

  //金币中心
  // GOLD_CONFIG:{id:12301,icon:'gold_config'},//金币配置
  // GOLD_DETAILS:{id:12302,icon:'gold_details'},//金币详情
  // GOODS_CONFIG:{id:12303,icon:'goods_config'},//商品配置
  // EXCHANGE_TASK:{id:12304,icon:'exchange_task'},//兑换任务
  // GOLD_AWARD:{id:12305,icon:'gold_award'},//金币授予

  //掌上学院
  // EXAM_CENTRE:{id:11001,icon:'college_exam'},//考试中心
  // STUDY_CENTRE:{id:11005,icon:'study_center'},//学习中心
  // COURSE_MANAGE:{id:11002,icon:'college_course'},//课程管理
  // PAPER_CONFIG:{id:11003,icon:'paper_config'},//试卷配置
  // MARK_TASK:{id:11004,icon:'college_readpaper'},//阅卷任务
  // QUESTION_BANK:{id:11006,icon:'question_bank'},//题库
  // ENTERPRISE_CONFIG:{id:11007,icon:'enterprise_config'},//企业内训配置

  //问卷调查
  QUESTIONNAIRE_FORM: { id: 12401, icon: 'questionnaire_form' }, //问卷表单
  // QUESTIONNAIRE_STATISTICS:{id:12402,icon:'questionnaire_statistics'},//问卷统计
  // QUESTIONNAIRE_CONFIG:{id:12403,icon:'questionnaire_config'},//问卷配置

  //店报
  SHOPPAPER_CREATE: { id: 11701, icon: 'storepaper_create' }, //创建店报
  SHOPPAPER_LIST: { id: 11702, icon: 'storepaper_list' }, //店报列表
  //SHOPPAPER_CATEGORY:{id:11704,icon:'shoppaper_category'},//店报分类

  //考勤管理
  SHIFT_REPORT: { id: 11101, icon: 'attendance_report' }, //考勤报表
  // SHIFT_CONFIG:{id:11102,icon:'attendance_config'},//考勤配置

  //工作圈
  HANDOVER_BOOK_DETAILS: { id: 10200, icon: 'workcircle' }, //工作圈
  // HANDOVER_BOOK_CONFIG:{id:10201,icon:'handover_book_config'},//工作圈配置
  // HANDOVER_BOOK_REPORT:{id:10202,icon:'workcircle_report'},//工作圈报表

  //顾客意见
  // CUSTOMER_FEEDBACK_REPORT:{id:12501,icon:'customer_feedback_report'},//顾客意见报表
  // CUSTOMER_FEEDBACK_CONFIG:{id:12502,icon:'customer_feedback_config'},//顾客意见配置

  //积分
  // INTEGRAL_CONFIG:{id:12601,icon:'integral_config'},//积分配置

  //人脸客流
  FACE_CUSTOMER_REPORT: { id: 11401, icon: 'member_report' }, //人脸客流报表
  FACE_CUSTOMER: { id: 11403, icon: 'shop_customer' }, //进店顾客
  // FACE_PERSONNEL_MGMT:{id:11404,icon:'member_recept'},//人员管理
  // FACE_CAPTURE:{id:11402,icon:'face_capture'},//抓拍记录
  // FACE_SETTING:{id:11405,icon:'device_face'},//设置
  // BAGUETTE_TIME:{id:11406,icon:'baguette_time'},//进店时间
  // FACE_PARAMETER_ANALYSIS:{id:11407,icon:'face_parameter_analysis'},//参数分析
  // FACE_DEVICE_OPERATE_CONDITION:{id:11408,icon:'face_device_operate_condition'},//人脸设备运营情况

  //接待簿
  // CUSTOMER_CAPTURE_RECORDS:{id:12701,icon:'customer_face_capture'},//抓拍记录
  // CUSTOMER_INFORMATION_SETTING:{id:12702,icon:'customer_information_setting'},//设置
  // VIEW_PERSONNEL_MANAGEMENT:{id:12703,icon:'customer_archives'},//人员档案
  // CUSTOMER_ANALYSIS:{id:12704,icon:'customer_analysis'},//顾客分析
  // CUSTOMER_MY:{id:12705,icon:'customer_my'},//我的客户
  // RECEPTION_RECORD: {id: 12706, icon:'reception_record'}, // 接待记录

  //黑名单
  // BLACKLIST_BATCH_CREATE:{id:12801,icon:'blacklist_batch_create'},//批量创建黑名单
  BLACKLIST_STATISTICS_REPORT: {
    id: 12802,
    icon: 'blacklist_statistics_report',
  }, //黑名单统计报表

  //运营分析
  // CUSTOMER_FLOW_PERFORMANCE:{id:10112,icon:'custom_flow_performance'},//客流绩效
  CUSTOMER_FLOW_BOOK: { id: 10101, icon: 'customer_flow_book' }, //看板
  CUSTOMER_DATA_VISUALIZATION: {
    id: 10102,
    icon: 'customer_data_visualization',
  }, //管理驾驶舱
  CUSTOMER_DATA: { id: 10103, icon: 'customer_data' }, //数据
  // CUSTOMER_CLASSIFICATION:{id:10110,icon:'customer_classification'},//分类
  CUSTOMERFLOW_CONFIG: { id: 10117, icon: 'custom_flow_performance' }, // 客流配置

  //客流
  // CUSTOMER_FLOW_TREND:{id:10104,icon:'custom_flow_trend'},//趋势
  // CUSTOMER_FLOW_DATA:{id:10113,icon:'custom_flow_data'},//数据
  // CUSTOMER_FLOW_DISTRIBUTE:{id:10105,icon:'custom_flow_distribute'},//分布
  // CUSTOMER_FLOW_ACTIVITY:{id:10106,icon:'custom_flow_activity'},//活动
  // CUSTOMER_FLOW_WEATHER:{id:10107,icon:'custom_flow_weather'},//天气
  // CUSTOMER_FLOW_WEEK:{id:10108,icon:'custom_flow_week'},//星期
  // CUSTOMER_FLOW_RANK:{id:10109,icon:'custom_flow_rank'},//排名
  // CUSTOMER_FLOW_SETTING:{id:10111,icon:'custom_flow_setting'},//设置
  // CUSTOMER_FLOW_CLASS:{id:10114,icon:'custom_flow_class'},//分类
  // CUSTOMER_FLOW_BOOK_1:{id:10115,icon:'custom_board'},//看板

  //热点
  HOTSPOT_DATA: { id: 10501, icon: 'hotspot_index' }, //热点数据
  HOTSPOT_PLAN: { id: 10502, icon: 'hotspot_map' }, //热点平面图
  HOTSPOT_DATA_ANALYSIS: { id: 10503, icon: 'hotspot_data_analysis' }, //热点数据分析

  //智慧车间
  ACCESS_RECORD: { id: 12901, icon: 'access_record' }, //进出记录
  // SERVICE_RECORDS:{id:12902,icon:'service_record'},//服务记录
  // INSPECTION_RECORDS:{id:12903,icon:'inspection_records'},//环检记录
  // STORE_CONFIG:{id:12904,icon:'shop_config'},//门店配置
  TRAFFIC_FLOW: { id: 12905, icon: 'traffic_flow' }, //车流量
  // DATA_DETAIL:{id:12906,icon:'data_detail'},//数据详情
  // WORK_ORDERS:{id: 12907,icon:'data_detail'}, //工单管理
  // PARKING_ANALYSIS: {id: 12908, icon:'parking_analysis'}, // 车位分析

  //运营管理
  // USER_PORTRAIT_REPORT:{id:11301,icon:'user_portrait'},//用户行为报表
  // USER_REPORT:{id:11302,icon:'user_report'},//用户报告
  // OPERATION_DATA:{id:11303,icon:'data-report'},//运营数据
  // EXCEPTION_DEVICE:{id:11304,icon:'exception_device'},//异常设备列表
  // OPERATION_CAROUSEL:{id:11305,icon:'operation_carousel'},//轮播图配置
  // OPERATION_OVOLICENSE:{id:11306,icon:'ovostation_ctrl'},//ovostation配置
  // FRIEND_LINK_CONFIG:{id:11307,icon:'friend_link_config'},//友情链接配置
  // DEVICE_VERSION_MANAGE:{id:11308,icon:'device_version_manage'},//设备版本管理
  // IM_CUSTOMER_CONFIG:{id:11309,icon:'im_customer_config'},//IM客服组配置
  // PROJECT:{id:11310,icon:'project'},//工程归档
  // APP_PROMOTION:{id:11311,icon:'app_promotion'},//APP推广

  //商城商品
  // API_LIST:{id:13001,icon:'storepaper_create'},//API列表
  // DOCUMENTS_LIST:{id:13002,icon:'storepaper_create'},//文档列表
  // TEMPLATE_CONFIG:{id:13003,icon:'template_config'},//模板配置
  // SMALL_PROGRAM:{id:13004,icon:'small_program'},//小程序授权
  // SHOP_GOODS_CONFIG:{id:13005,icon:'shop_goods_config'},//商品配置
  // SHOP_USER_CENTER:{id:13006,icon:'shop_user_center'},//用户中心
  // SHOP_ORDER_CENTER:{id:13007,icon:'shop_order_center'},//订单中心
  // COUPONS:{id:13008,icon:'coupons'},//优惠券
  // ACTIVITY_CONFIG:{id:13009,icon:'activity_config'},//活动配置

  //基础平台
  ENTERPRISE_MANAGE: { id: 13101, icon: 'system_enterprise' }, //企业管理
  ORGANIZE_ARCHITECTURE: { id: 13102, icon: 'system_organize' }, //组织架构
  SHOP_MANAGE: { id: 13103, icon: 'system_store' }, //门店管理
  ROLE_MANAGE: { id: 13104, icon: 'role_manage' }, //角色管理
  MEDAL_MANAGEMENT: { id: 13119, icon: 'badge_manage' }, //徽章管理
  // USER_MANAGE:{id:13105,icon:'system_user'},//用户管理
  // LOG_MANAGE:{id:13106,icon:'log_manage'},//日志管理
  // AUDIT_CONFIG:{id:13107,icon:'audit_config'},//审批配置
  // ENTERPRISE_CAROUSEL:{id:13108,icon:'enterprise_carousel'},//企业轮播图
  // QA_NEWS:{id:13109,icon:'qa_news'},//QA&新闻
  // APP_HOME_ICON_CONFIG:{id:13110,icon:'app_home_icon_config'},//APP首页图标设置
  // NOTIFICATIONS:{id:13111,icon:'notifications'},//小秘书
  // PROJECT_MANAGE:{id:13112,icon:'project_managr'},//项目管理
  // PLANTFORM_MANAGE:{id:13113,icon:'plantform_manage'},//平台管理
  // AGENT_MANAGE:{id:13114,icon:'agent_manage'},//代理商管理
  // OTHER_MANAGE:{id:13115,icon:'other_manage'},//其他管理
  // APP_STARTPAGE:{id:13116,icon:'app_startpage'},//APP启动页
  // SHOPSCENARIO_GOODSASSOCIATED:{id:13117,icon:'shopscenario_goodsassociated'},//门店场景与商品关联
  // ENTERPRISE_OPENFUNCTION:{id:13118,icon:'enterprise_openfunction'},//企业功能开通

  //设备管理
  DEVICE_ADD: { id: 13201, icon: 'device_add' }, //添加设备
  DEVICE_MANAGEMENT: { id: 13202, icon: 'device_manage' }, //设备管理
  DEVICE_REPORT: { id: 13203, icon: 'device_report' }, //设备报表
  DEVICE_DOCK: { id: 13204, icon: 'device_buttjoint' }, //设备对接
  // VIDEO_DEVICE_MANAGE:{id:13205,icon:'video_device_manage'},//视频设备配置
  // TRACK_DEVICE:{id:13206,icon:'track_device'},//追溯设备
  // THIRD_DEVICE_MANAGE:{id:13207,icon:'third_device_manage'},//三方设备管理
  // DEVICE_HISTORICAL_SNAPSHOT:{id:13208,icon:'device_historiccal_snapshot'},//设备历史抓拍
  // BIND_OUTSIDE_CUSTOMER_FLOW:{id:13209,icon:'device_add'},//绑定店外客流

  //营销管理
  XINFA_SYSTEM: { id: 11201, icon: 'infosend_config' }, //信发配置
  // INTERACTIVE_MARKETING:{id:11202,icon:'interactive_marketing'},//互动营销
  // XIAOYIN_MANAGE:{id:11203,icon:'xiaoyin_manage'},//小音管理
  // FACE_ENTRANCE_GUARD:{id:11204,icon:'face_entrance_guard'},//人脸门禁
  // CLOUD_SHELVES:{id:11205,icon:'cloud_shelves'},//云货架
  // DEVICE_MANAGE:{id:11206,icon:'yx_device_manage'},//设备管理
  // OPERATION_MANAGE:{id:11207,icon:'operation_manage'},//运营管理
  // PROBLEM_FEEDBACK:{id:11213,icon:'operation_manage'},//问题反馈

  //电视墙管理
  // OVOSTATION_CONTROL: {id: 11208, icon: 'ovostation_control'}, //电视墙控制
  // PREPLAN_ADD: {id: 11209, icon: 'perplan_add'}, //预案配置
  // OVOSTATION_CONFIG: {id: 11210, icon: 'ovostation_config'}, //电视墙配置

  //语音识别
  // VOICE_IDENTIFY: {id: 11211, icon: 'voice_identify'}, //语音识别

  //告警中心
  ALARM_CENTRE: { id: 11212, icon: 'alarm_center' }, // 告警中心
};
